import React from 'react'


function UpgradeListing() {
  
  return (
    <div className="border-[1px]">
      <div className="border-b-[1px]  h-[50px] flex items-center px-[10px] font-semibold text-[20px]">
        <h className="">Upgrade Your Listing</h>
      </div>
      <div className='py-[120px] px-[20px] text-center flex justify-center'>
        <span className='font-fair text-[#aca4a8] text-[16px]'>THERE IS NO PLAN RIGHT NOW.</span>
      </div>
    </div>
  )
}

export default UpgradeListing
